var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.c)?_c(_vm.c,{key:_vm.c.__file,tag:"component"}):_vm._e(),(_vm.newsletterData)?_c('Newsletter',{attrs:{"data":_vm.newsletterData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }